import React from 'react'
import type { ConnectionLineComponentProps } from 'reactflow'

function ConnectioinLine({
  fromX = 0,
  fromY = 0,
  toX = 0,
  toY = 0,
}: ConnectionLineComponentProps) {
  // const { connectionHandleId, connectionHandleType } = useStore((s) => {
  //   return {
  //     connectionHandleId: s.connectionHandleId ? s.connectionHandleId : undefined,
  //     connectionHandleType: s.connectionHandleType,
  //   }
  // })

  return (
    <g>
      <path
        style={{
          stroke: 'rgb(85, 130, 243)',
        }}
        fill="none"
        strokeWidth={1.5}
        className="animated"
        d={`M${fromX},${fromY} C ${fromX} ${toY} ${fromX} ${toY} ${toX},${toY}`}
      />
      <circle
        cx={toX}
        cy={toY}
        fill="#fff"
        r={3}
        style={{
          stroke: 'rgb(85, 130, 243)',
        }}
        strokeWidth={1.5}
      />
    </g>
  )
}

export default ConnectioinLine
